<template>
    <div style="transform:rotate(-90deg)">
        <svg height="100%" viewBox="0 0 20 20" width="100%" style="overflow: visible;">
            <circle cx="50%" cy="50%" fill="none" stroke-width="2" r="9" stroke="#E6ECF0" />
            <circle
                cx="50%"
                cy="50%"
                fill="none"
                stroke-width="2"
                r="9"
                stroke="#1DA1F2"
                stroke-linecap="round"
                :style="{'stroke-dashoffset': dashOffset, 'stroke-dasharray': dashArray}"
            />
        </svg>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            default: 0,
        },
        dashArray: {
            default: 56.5487
        }
    },
    computed: {
        dashOffset() {
            const diff = (100 - this.value) / 100;
            return this.dashArray * diff;
        }
    }
}
</script>